import { render, staticRenderFns } from "./ControlControlPanelPIP.vue?vue&type=template&id=006fdd3b&scoped=true&"
import script from "./ControlControlPanelPIP.vue?vue&type=script&lang=js&"
export * from "./ControlControlPanelPIP.vue?vue&type=script&lang=js&"
import style0 from "./ControlControlPanelPIP.vue?vue&type=style&index=0&id=006fdd3b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006fdd3b",
  null
  
)

export default component.exports